export default __webpack_public_path__ + "static/media/distanceIcon.64e2a818.svg";